var symphony = symphony || {};

;(function() {

  symphony.donationsModal = function() {

	$('.test-popup-link').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});

	symphony.config.utilities.modal = $.magnificPopup.instance;

  };


})();